import { render, staticRenderFns } from "./CreateMatch.vue?vue&type=template&id=1fd73b4b&"
import script from "./CreateMatch.vue?vue&type=script&lang=js&"
export * from "./CreateMatch.vue?vue&type=script&lang=js&"
import style0 from "./CreateMatch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports